import styled from 'styled-components';
import {animations, colors, devices} from '../../../utils/styled/_variables.styled';

export const InfiosBurgerLine = styled.span`
    position: absolute;
    display: flex;
    height: 16.67%;
    width: 100%;
    background: ${props => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.infiosGray : colors.white)};
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .15s ease-out;

    &:nth-child(1) {
        top: 0;
    }

    &:nth-child(2) {
        opacity: 0;
    }

    &:nth-child(2),
    &:nth-child(3) {
        top: 50%;
        transform: translateY(-50%) rotate(0deg);
    }

    &:nth-child(4) {
        top: auto;
        bottom: 0;
    }

    ${props => !props.isMobile && `
        display: none;
    `}
`;

export const InfiosBurgerWrapper = styled.section`
    position: relative;
    width: 30px;
    height: 20px;
    transform: rotate(0deg);
    transition: ${animations.defaultTransition};
    cursor: pointer;

    ${props => !props.isMobile && `
        display: none;
    `}

    &.active {
        ${InfiosBurgerLine} {
            &:nth-child(1) {
                top: 50%;
                transform: translateY(-50%) rotate(0deg);
                width: 0%;
                left: 50%;
            }
        }
    }

    &.active {
        ${InfiosBurgerLine} {
            &:nth-child(2) {
                transform: rotate(45deg);
                opacity: 1;
            }
        }
    }

    &.active {
        ${InfiosBurgerLine} {
            &:nth-child(3) {
                transform: rotate(-45deg);
            }
        }
    }

    &.active {
        ${InfiosBurgerLine} {
            &:nth-child(4) {
                top: 50%;
                transform: translateY(-50%) rotate(0deg);
                width: 0%;
                left: 50%;
            }
        }
    }

		&:hover {
			span {
				background: ${colors.limeGreen}!important;
			}
		}
`;
